module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-driver-approval row column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-4 small-12"
  }, [_c('SearchEntity', {
    attrs: {
      "entity": "drivers"
    },
    model: {
      value: (_vm.search.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "driver_id", $$v)
      },
      expression: "search.driver_id"
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('AccontStatusFilter', {
    attrs: {
      "statuses": ['document_status', 'subscription']
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)]), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "componentType": "approvalListing"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d1e6949!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/DriverApprovalQueue.vue
// module id = 2606
// module chunks = 1